import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const WmsDashboardPage = lazy(() => import('./pages/dashboard'))
const NotificationsPage = lazy(() => import('./pages/notifications'))

const generalRoutes: RouteObject[] = [
  {
    path: 'general',
    children: [
      {
        path: 'dashboard',
        element: <WmsDashboardPage />
      },
      {
        path: 'notifications',
        element: <NotificationsPage />
      }
    ]
  }
]

export default generalRoutes
